import { CommonModule } from '@angular/common';
import {APP_INITIALIZER, NgModule, Provider} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { FormioAppConfig } from '@formio/angular';
import { AppConfig, EnvConfig } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ModelModule } from './model/model.module';
import { MessagesModule } from 'primeng/messages';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxMatomoTrackerModule } from '@ngx-matomo/tracker';
import { KeycloakAngularModule, KeycloakService } from "keycloak-angular";
import { PagesModule } from "./pages/pages.module";
import {RECAPTCHA_SETTINGS, RecaptchaSettings} from "ng-recaptcha";

// Function for init comunication between angular and sso keycloak
function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        url: EnvConfig.sso_url,
        realm: EnvConfig.sso_realm,
        clientId: EnvConfig.sso_clientId,
      },
      initOptions: {
        onLoad: "check-sso",
        silentCheckSsoRedirectUri: `${window.location.origin}/assets/silent-check-sso.html`,
        redirectUri: window.location.origin,
        checkLoginIframe: true,
      }
    });
}

const providers: Provider[] = [
  { provide: FormioAppConfig, useValue: AppConfig },
  {
    provide: RECAPTCHA_SETTINGS,
    useValue: {
      siteKey: "6LeocAQfAAAAAA9xIf4UhQcxaQRB2LM1eBOgGC8d",
      size: "invisible"
    } as RecaptchaSettings,
  },
];
if (EnvConfig.auth_SPID && EnvConfig.auth_SPID.toUpperCase() === 'TRUE') {
  providers.push({
    provide: APP_INITIALIZER,
    useFactory: initializeKeycloak,
    multi: true,
    deps: [KeycloakService],
  });
}
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    ModelModule,
    FormsModule,
    MessagesModule,
    BrowserAnimationsModule,
    KeycloakAngularModule,
    PagesModule,
    NgxMatomoTrackerModule.forRoot({
      siteId: EnvConfig.matomoSiteId,
      trackerUrl: EnvConfig.matomoTrackerUrl,
    }),
    NgxMatomoTrackerModule,
  ],
  providers: providers,
  bootstrap: [AppComponent]
})


export class AppModule {}
